<template>

  <div class="user">
    <el-form size="small" ref="form" :model="form" label-width="150px">
      <el-form-item label="是否开启" prop="is_coupon">
        <el-switch v-model="form.status"></el-switch>
      </el-form-item>


         <el-form-item label="检修说明" prop="is_coupon">
        <el-input v-model="form.notice"></el-input>
      </el-form-item>

       <el-form-item label="bannar：" prop="model.jx_banners">
      <div class="draggable-list">
        <draggable class="wrapper" v-model="form.jx_banners">
          <transition-group>
            <div v-for="(item, index) in form.jx_banners" :key="item.file_path">
              <div class="item">
                <img v-img-url="item.file_path" alt="file_path"/>
                <a href="javascript:void(0);" class="delete-btn" @click.stop="deleteJxBanner(index,'album')"><i class="el-icon-close"></i></a>
              </div>
            </div>
          </transition-group>
        </draggable>
        <div class="item img-select" @click="openJxUpload('album')">
          <i class="el-icon-plus"></i>
        </div>
      </div>
    </el-form-item>
    </el-form>

    
    <!--提交-->
    <div class="common-button-wrapper">
      <el-button size="small" type="primary" @click="onSubmit" :disabled="loading">保存</el-button>
    </div>
        <Upload 
      v-if="isJxBannerUpload" 
      :config="{ total: 1 }" 
      :isupload="isJxBannerUpload" 
      @returnImgs="handleJxImgUpload">
      上传图片
    </Upload>
    <!--商品图片组件-->
    <!-- <Upload v-if="isProductUpload" :config="{ total: 9 }" :isupload="isProductUpload" @returnImgs="returnProductImgsFunc">上传图片</Upload> -->
  </div>
</template>
<script>
import Maintenance_serviceApi from '@/api/maintenance_service.js';
import Upload from '@/components/file/Upload';
import draggable from 'vuedraggable';
export default {
  components: {
    Upload,
    draggable
  },
  data() {
    return {
      isJxBannerUpload:false,
      currentJxIndex: -1,
      form: {
        status: false,
        jx_banners: [
        ],
      },
      setting: [],
      loading: false,
      isProductUpload:false
    };
  },
  created() {
    /*获取列表*/
    this.getSetting();
  },
  methods: {
      deleteJxBanner(index) {
      this.form.jx_banners.splice(index, 1)
    },

    openJxUpload(index) {
    
      this.isJxBannerUpload = true
    },
   /*上传商品图片*/
    handleJxImgUpload(e) {
       if (e != null) {
        let imgExpt = ["bmp", "jpg", "jpeg", "png", "gif"];
        let prevent = false;
        console.log(typeof imgExpt);
        e.forEach((element) => {
          let data_array = element.file_path.split(".");
          let ext = data_array[data_array.length - 1];
          imgExpt.forEach((e) => {
            if (e === ext) {
              prevent = true
              return false
            }
          });
        });

        if (!prevent) {
          this.$message.error("图片类型有误,请选择正确的图片格式");
          return false;
        }
        let imgs = [];
        if( this.form.jx_banners){
          imgs = this.form.jx_banners.concat(e);
        }else{
          imgs = e;
        }
      
        this.$set(this.form, "jx_banners", imgs);
      }
      
      this.isJxBannerUpload = false;
    },


    /*获取设置*/
    getSetting() {
      let self = this;
      let Params = {};
      Maintenance_serviceApi.getSetting(Params, true)
        .then(data => {
          self.loading = false;
          console.log(data)
          if(data.data.vars.values!='[]'){
            self.form = data.data.vars.values;
          }
              // 处理检修服务banner数据，如果是单个对象则转为数组
          if(self.form.jx_banners!='[]'){
             self.forms.jx_banners = []
           
          }
          console.log('  self.forms.jx_banners',  self.forms.jx_banners)
          
        })
        .catch(error => {});
    },
    /*点击保存*/
    onSubmit() {
      let self = this;
      let params = self.form;
      self.loading = true;
      Maintenance_serviceApi.saveSetting(params, true)
        .then(data => {
          self.loading = false;
          if (data.code == 1) {
            self.$message({
              message: '恭喜你，保存成功',
              type: 'success'
            });
            self.getSetting();
          } else {
            self.loading = false;
          }
        })
        .catch(error => {
          self.loading = false;
        });
    },

  }
};
</script>

<style>
.draggable-list {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}
.draggable-list .wrapper > span {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.draggable-list .item {
  position: relative;
  width: 110px;
  height: 110px;
  margin-top: 10px;
  margin-right: 10px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #dddddd;
}

.draggable-list .delete-btn {
  position: absolute;
  top: 0;
  right: 0;
  width: 16px;
  height: 16px;
  background: red;
  line-height: 16px;
  font-size: 16px;
  color: #ffffff;
  display: none;
}

.draggable-list .item:hover .delete-btn {
  display: block;
}

.draggable-list .item img {
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  max-height: 100%;
  max-width: 100%;
}

.draggable-list .img-select {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px dashed #dddddd;
  font-size: 30px;
}

.draggable-list .img-select i {
  color: #409eff;
}
</style>



// WEBPACK FOOTER //
// src/views/plus/maintenance_service/setting/getSetting.vue